const INIT = 'INIT';
const LOADING = 'LOADING';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';
const UNAUTH_USER = 'UNAUTH_USER';
const UNAUTH_USER_SUCCESS = 'UNAUTH_USER_SUCCESS';
const UNAUTH_USER_ERROR = 'UNAUTH_USER_ERROR';
const API_URL = process.env.REACT_APP_API_URL;
const VERSION_ID =100;
const PROGRAM_ID = 101;
const ANALYTICS_ID = 102;
export {
  INIT,
  LOADING,
  SUCCESS,
  ERROR,
  API_URL,
  UNAUTH_USER,
  UNAUTH_USER_SUCCESS,
  UNAUTH_USER_ERROR,
  VERSION_ID,
  PROGRAM_ID,
  ANALYTICS_ID
};
